



























import { Prop, Watch, Vue, Component } from "vue-property-decorator";

@Component
export default class InputNumber extends Vue {
  @Prop({ type: String, required: false })
  id!: string;
  @Prop({ type: String, required: true })
  name!: string;
  @Prop({ type: Number, required: true })
  value!: number;
  @Prop({ type: String, required: false })
  error!: string;
  @Prop({ type: String, required: false })
  placeholder!: string;
  @Prop({ type: Boolean, required: false })
  hasIcon!: boolean;
  @Prop({ type: Boolean, required: false })
  hasSuffix!: boolean;
  @Prop({ type: Number, required: false })
  step!: number;
  @Prop({ type: Number, required: false })
  min!: number;
  @Prop({ type: Number, required: false })
  max!: number;

  numberValue = this.value;

  updateValue(e: any) {
    const targetValue = e.target.value;
    let replacedValue = "";
    replacedValue = String(targetValue).replace(/[０-９]/g, s =>
      String.fromCharCode(s.charCodeAt(0) - 65248)
    );
    replacedValue = replacedValue.replace(/[^0-9]/g, "");
    this.numberValue = replacedValue ? parseInt(replacedValue, 10) : this.min;
  }
  validateValue(e: any) {
    e = e || window.event;
    let key = e.keyCode || e.which;
    key = String.fromCharCode(key);
    const regex = /[0-9]/;
    if (!regex.test(key)) {
      e.returnValue = false;
      if (e.preventDefault) e.preventDefault();
    }
  }
  changeCount(count: number) {
    this.numberValue = count;
  }

  @Watch("numberValue")
  onNumberValue(newValue: number, oldValue: number) {
    if (newValue <= this.min) {
      this.numberValue = parseInt(this.min.toString(), 10);
    }
    if (newValue >= this.max) {
      this.numberValue = parseInt(this.max.toString(), 10);
    }
    if (newValue <= this.max && newValue >= this.min) {
      this.$emit("input", newValue, oldValue);
    }
  }
}
